function isNativeHTMLTag(tag: string) {
  const tagName = tag.replace(/[<>]/g, "");
  const element = document.createElement(tagName);
  return element instanceof HTMLElement && !(element instanceof HTMLUnknownElement);
}

export function isNativeHTML(htmlString: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const allElements = doc.getElementsByTagName("*");

  for (const el of allElements) {
    if (!isNativeHTMLTag(el.tagName.toLowerCase())) {
      return false;
    }
  }

  return true;
}

const RANDOM_STRING_RADIX = 36;
const RANDOM_STRING_START = 2;
const RANDOM_STRING_END = 6;

const generateClassName = (() => {
  let counter = 0;
  return (customClass: string = "user-style") => {
    counter += 1;
    const random = Math.random()
      .toString(RANDOM_STRING_RADIX)
      .slice(RANDOM_STRING_START, RANDOM_STRING_END);
    return `${customClass}-${counter}-${random}`;
  };
})();

export const convertInlineStylesToClasses = (
  html: string,
  nonce: string,
  customClass: string = "user-style"
) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const styleMap = new Map<string, string>();
  let styleBlock = "";

  doc.body.querySelectorAll<HTMLElement>("[style]").forEach((el) => {
    const styleText = el.getAttribute("style")?.trim();
    if (!styleText) {
      return;
    }

    let className = styleMap.get(styleText);
    if (!className) {
      className = generateClassName(customClass);
      styleMap.set(styleText, className);
      styleBlock += `.${className} { ${styleText} }\n`;
    }

    el.removeAttribute("style");
    el.classList.add(className);
  });

  if (styleBlock) {
    const styleEl = doc.createElement("style");
    styleEl.setAttribute("nonce", nonce);
    styleEl.textContent = styleBlock;
    doc.body.prepend(styleEl);
  }

  return doc.body.innerHTML;
};
